import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { checkToken, openSidebar } from '../Redux/Dashboard/DashboardSlice';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faHome, faSignOutAlt, faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';
import EventNoteIcon from '@mui/icons-material/EventNote';
import PeopleIcon from '@mui/icons-material/People';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import DownloadIcon from '@mui/icons-material/Download';
import SendIcon from '@mui/icons-material/Send';
import Box from '@mui/material/Box';
import '../Style/Sidebar.css';

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isOpen = useSelector((state) => state.DashboardSlice.dashShow);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const sidebarRef = useRef(null);

  const menuItems = [
    { name: 'Home', icon: faHome, path: '/home' },
    { name: 'Courses', icon: EventNoteIcon, path: '/courses', isMaterialIcon: true },
    { name: 'Students', icon: PeopleIcon, path: '/studentsList', isMaterialIcon: true },
    { name: 'Enquiry', icon: ContactSupportIcon, path: '/enquiry', isMaterialIcon: true },
    // { name: 'Transactions', icon: faMoneyCheckAlt, path: '/transaction' },
    { name: 'All Videos', icon: OndemandVideoIcon, path: '/allVideos', isMaterialIcon: true },
    { name: 'Download Videos', icon: DownloadIcon, path: '/allVideosDetails', isMaterialIcon: true },
    { name: 'Send Notification', icon: SendIcon, path: '/notification', isMaterialIcon: true },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    dispatch(openSidebar(false));
  };

  // Close sidebar on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        dispatch(openSidebar(false));
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, dispatch]);

  return (
    <Box
      ref={sidebarRef}
      className={`sidebar-container ${isOpen ? 'open' : 'closed'}`}
      sx={{
        zIndex: 5000,
        visibility: isOpen ? 'visible' : 'hidden',
        transition: 'transform 0.3s ease',
        transform: isOpen ? 'translateX(0)' : 'translateX(-200px)',
        ...(isIOS && {
          WebkitTransform: 'translateZ(0)',
          WebkitBackfaceVisibility: 'hidden',
        }),
      }}
    >
      <button className="close-btn-sidebar" onClick={() => dispatch(openSidebar(false))}>
        <FontAwesomeIcon icon={faBars} />
      </button>

      <ul className="menu-list">
        {menuItems.map((item, index) => (
          <li
            key={index}
            onClick={() => handleNavigation(item.path)}
            className="menu-item"
            style={{ '--index': index }}
          >
            {item.isMaterialIcon ? (
              <item.icon style={{ cursor: 'pointer' }} className="menu-icon" />
            ) : (
              <FontAwesomeIcon style={{ cursor: 'pointer' }} icon={item.icon} className="menu-icon" />
            )}
            {item.name}
          </li>
        ))}
        <li className="mt-4">
          <button
            className="logout-btn"
            onClick={() => {
              localStorage.clear();
              navigate('/');
              window.scrollTo({ top: 0, behavior: 'smooth' });
              dispatch(checkToken(false));
              dispatch(openSidebar(false));
            }}
          >
            <FontAwesomeIcon icon={faSignOutAlt} className="menu-icon" /> Logout
          </button>
        </li>
      </ul>
    </Box>
  );
};

export default Sidebar;